// assets
import { ClockCircleOutlined } from '@ant-design/icons';

// icons
const icons = {
  ClockCircleOutlined
};

const subcontractor = {
  id: 'subcontractor',
  title: '',
  type: 'group',
  roles: ['subcontractor'],
  children: [
    {
      id: 'timetracking',
      title: 'Time Tracking',
      type: 'item',
      url: '/subcontractor/timetracking',
      icon: icons.ClockCircleOutlined,
      requiredFeature: 'time_tracking'
    }
  ]
};

export default subcontractor;
